<template>
  <div class="page-content-wrapper" v-check-permission="'edit-examination-tables'">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card m-b-20">
            <div class="card-block">
              <h4 class="mt-0 header-title">Mesas de exámen</h4>

              <template v-if="examinationTable">

                <div class="form-group" v-bind:class="{ 'has-danger': $v.examinationTable.name.$error }">
                  <label>Nombre</label>
                  <input type="text" class="form-control col-md-6" v-model="examinationTable.name" @input="$v.examinationTable.name.$touch()">
                  <div class="form-control-feedback" v-if="!$v.examinationTable.name.required && $v.examinationTable.name.$error">El nombre es requerido.</div>
                </div>

                <div class="form-group">
                  <label>Llamado</label>
                  <input type="text" class="form-control col-md-6" v-model="examinationTable.called">
                </div>

                <div class="form-group">
                  <label>Descripción</label>
                  <textarea class="form-control col-md-6" v-model="examinationTable.description"></textarea>
                </div>

                <div class="form-group" v-bind:class="{ 'has-danger': $v.examinationTable.dateFrom.$error }">
                  <label>Fecha de la inscripción</label>
                  <div class="row">
                    <div class="col-md-3">
                      <small>Desde:</small>
                      <masked-input mask="1111-11-11" type="text" class="form-control" v-model="examinationTable.dateFrom" @input="$v.examinationTable.dateFrom.$touch()" />
                      <small>(YYYY-MM-DD)</small>
                      <div class="form-control-feedback" v-if="!$v.examinationTable.dateFrom.required && $v.examinationTable.dateFrom.$error">La fecha desde es requerida.</div>
                    </div>
                    <div class="col-md-3">
                      <small>Hasta:</small>
                      <masked-input mask="1111-11-11" type="text" class="form-control" v-model="examinationTable.dateTo" @input="$v.examinationTable.dateTo.$touch()" />
                      <small>(YYYY-MM-DD)</small>
                      <div class="form-control-feedback" v-if="!$v.examinationTable.dateTo.required && $v.examinationTable.dateTo.$error">La fecha hasta es requerida.</div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>Fecha de publicación de listas</label>
                  <div class="row">
                    <div class="col-md-3">
                      <small>Desde:</small>
                      <masked-input mask="1111-11-11" type="text" class="form-control" v-model="examinationTable.publishListsFrom"/>
                      <small>(YYYY-MM-DD)</small>
                    </div>
                    <div class="col-md-3">
                      <small>Hasta:</small>
                      <masked-input mask="1111-11-11" type="text" class="form-control" v-model="examinationTable.publishListsTo" />
                      <small>(YYYY-MM-DD)</small>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>Fecha de los exámenes</label>
                  <div class="row">
                    <div class="col-md-3">
                      <small>Desde:</small>
                      <masked-input mask="1111-11-11" type="text" class="form-control" v-model="examinationTable.examsFrom"/>
                      <small>(YYYY-MM-DD)</small>
                    </div>
                    <div class="col-md-3">
                      <small>Hasta:</small>
                      <masked-input mask="1111-11-11" type="text" class="form-control" v-model="examinationTable.examsTo" />
                      <small>(YYYY-MM-DD)</small>
                    </div>
                  </div>
                </div>



                <div class="form-group">
                  <label>Ultima cuota requerida para la inscripción</label>
                  <div class="row">
                    <div class="col-md-1">
                      <select class="custom-select form-control" v-model="examinationTable.monthOfTheLastPaymentRequired">
                        <option :value="null">Mes</option>
                        <option v-for="m in months" v-bind:value="m.value">
                          {{ m.value }} ({{ m.text }})
                        </option>
                      </select>
                    </div>

                    <div class="col-md-1">
                      <select class="custom-select form-control" v-model="examinationTable.yearOfTheLastPaymentRequired">
                        <option :value="null">Año</option>
                        <option v-for="i in years" v-bind:value="i">
                          {{ i }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <small>Al seleccionar mes y año, estaras condicionando a que el alumno pueda inscribirse a la mesa solo si tiene pagada la cuota correspondiente al mes/año seleccionado.</small>
                </div>


                <div class="form-group  m-b-0">
                  <label>Estado</label>
                  <div>
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="examinationTable.active">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">Activo</span>
                    </label>
                  </div>
                </div>

                <div class="form-group  m-b-0" v-bind:class="{ 'has-danger': $v.examinationTable.careers.$error }">
                  <label>Carreras</label>
                  <div v-for="career in careers">
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-bind:value="career._id" v-model="examinationTable.careers">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">{{ career.name }}</span>
                    </label>
                  </div>
                  <div class="form-control-feedback" v-if="!$v.examinationTable.careers.required && $v.examinationTable.careers.$error">Debes seleccionar al menos 1 carrera.</div>
                </div>

                <div class="card-block pull-right pr-0">
                  <router-link to="/examination-tables" class="btn btn-secondary waves-effect m-r-10">Cancelar</router-link>
                  <a href="javascript:void(0);" class="btn btn-primary waves-effect waves-light save-btn" @click="submit()">Guardar</a>
                </div>

              </template>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import MaskedInput from 'vue-masked-input'
  import months from '../data/months'

  export default {

    name: 'edit-examination-tables',


    components: {
      MaskedInput
    },


    created () {
      this.getExaminationTable();
      this.getAllCareers();
    },


    data () {
      return {
        months: months
      }
    },


    computed: {
      examinationTable: function () {
        return this.$store.getters.getExaminationTable
      },

      careers: function () {
        return this.$store.getters.getAllCareers
      },

      years: function () {
        var minYear = 2018;
        var currentYear = (new Date()).getFullYear();
        var years = [];
        var i;

        for (i = minYear; i <= (currentYear + 1); i++) {
          years.push(i);
        }

        return years;
      }
    },


    validations: {
      examinationTable: {
        name: {
          required
        },
        dateFrom: {
          required
        },
        dateTo: {
          required
        },
        careers: {
          required
        }
      }
    },


    methods: {

      submit: function () {
        const self = this;
        this.$v.examinationTable.$touch()

        if(!this.$v.examinationTable.$error) {
          $('.save-btn').attr('disabled', true);

          this.$store.dispatch('editExaminationTable', {examinationTable: this.examinationTable})
            .then((response) => {

              if(response.success) {
                self.$message.success();

                setTimeout(function () {
                  self.$router.push('/examination-tables')
                }, 500)

              } else {
                self.$message.error({text: response.message});
              }

              $('.save-btn').attr('disabled', false)
            })
            .catch((response) => {
              self.$message.error({text: response.message});
              $('.save-btn').attr('disabled', false)
            })
        }
      },


      getExaminationTable: function () {
        const self = this;
        this.$loader.loading();

        this.$store.dispatch('getExaminationTable', { id : this.$route.params.id })
          .then((response) => {
            if(response.data) self.examinationTable.dateFrom = response.data.dateFrom.split('T')[0];
            if(response.data) self.examinationTable.dateTo = response.data.dateTo.split('T')[0];
            if(response.data && self.examinationTable.publishListsFrom) self.examinationTable.publishListsFrom = response.data.publishListsFrom.split('T')[0];
            if(response.data && self.examinationTable.publishListsTo) self.examinationTable.publishListsTo = response.data.publishListsTo.split('T')[0];
            if(response.data && self.examinationTable.examsFrom) self.examinationTable.examsFrom = response.data.examsFrom.split('T')[0];
            if(response.data && self.examinationTable.examsTo) self.examinationTable.examsTo = response.data.examsTo.split('T')[0];
            this.$loader.close();
          })
          .catch(error => {
            this.$message.error({ text: error });
            this.$loader.close();
          })
      },


      getAllCareers () {
        this.$loader.loading();

        this.$store.dispatch('getAllCareers')
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$message.error({ text: error });
            this.$loader.close();
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/EditExaminationTablesScreen.vue